/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_connect_agent_banner_description = /** @type {(inputs: {}) => string} */ () => {
	return `Dale a tu agente de IA capacidades financieras — transferencias, tarjetas, pagos y más.`
};

const en_connect_agent_banner_description = /** @type {(inputs: {}) => string} */ () => {
	return `Give your AI agent financial capabilities — transfers, cards, payments, and more.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const connect_agent_banner_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.connect_agent_banner_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("connect_agent_banner_description", locale)
	if (locale === "es") return es_connect_agent_banner_description(inputs)
	return en_connect_agent_banner_description(inputs)
};
export { connect_agent_banner_description as "connect_agent.banner_description" }